<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>工单分配至相应承办单位
        </div>
        <div class="workordr_content">
            <el-form label-width="146px"
                     :model="ruleForm"
                     label-position="left"
                     ref="ruleFormRef"
            >
                <div class="workordr_content_title">
                    <div class="workordr_content_title_left">
                        <span></span>
                        <p>承办单位</p>
                    </div>
                </div>
                <div style="background-color: white;padding: 0 12px 12px;">
                    <div class="workordrAssign_unit">
                        <el-form-item label="承办单位" :prop="['userCodes',0,'assignee_array']"
                                      :rules="{
                                    required: true,
                                    message: '请选择承办单位',
                                    trigger: 'blur',
                                  }">
                            <el-cascader
                                v-model="ruleForm.userCodes[0].assignee_array"
                                :options="cbUnit"
                                clearable
                                :props="{
                                    value:'deptId',
                                    emitPath:false
                                }"
                                filterable
                                @change="getCheckedNodes"

                            />
                            <div :class="{'active':ruleForm.userCodes[0].type==='false'?false:ruleForm.userCodes[0].type}" class="workordrAssign_unit_mainBtn"
                                 @click="mainResponsibilityChange('userCodes',0)">
                                主责
                            </div>
                            <el-button @click="addHoldUnit">
                                <el-icon>
                                    <plus/>
                                </el-icon>
                            </el-button>
                        </el-form-item>
                        <el-form-item label="承办单位" v-for="(item,index) in ruleForm.userCodes.slice(1)"
                                      :prop="['userCodes',index+1,'assignee_array']"
                                      :rules="{
                                    required: true,
                                    message: '请选择承办单位',
                                    trigger: 'blur',
                                  }"
                        >
                            <el-cascader
                                v-model="ruleForm.userCodes[index+1].assignee_array"
                                clearable
                                :props="{
                                    value:'deptId',
                                    emitPath:false
                                }"
                                filterable
                                :options="cbUnit"
                            />
                            <div :class="{'active':ruleForm.userCodes[index+1].type==='false'?false:ruleForm.userCodes[index+1].type}"
                                 class="workordrAssign_unit_mainBtn"
                                 @click="mainResponsibilityChange('userCodes',index+1)">
                                主责
                            </div>
                            <el-button @click="reduceHoldUnit(index+1)">
                                <el-icon>
                                    <minus/>
                                </el-icon>
                            </el-button>
                        </el-form-item>
                    </div>
                    <el-form-item label="处理时限" prop="clsx" :rules="[{
                                    required: true,
                                    message: '请输入处理时限',
                                    trigger: 'change',
                                  },
                                  {
                                    message: '请输入数字',
                                    trigger: 'change',
                                    type: 'number',
                                  }]">
                        <div class="el-form-item_list" style="display: flex;width: 50%;">
                            <el-input type="number" @input="clsxDayInput" v-model="ruleForm.czFpclsxzrr"/>
                            <span>个自然日</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="承办单位截止日期">
                        <el-date-picker
                            type="datetime"
                            placeholder="选择日期"
                            disabled
                            v-model="ruleForm.czFpdxjzrq"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item label="指挥中心处理意见"
                                  prop="czCzjgwb"
                                  :rules="{
                                    required: true,
                                    message: '请输入指挥中心处理意见',
                                    trigger: 'blur',
                                  }">
                        <el-input maxlength="2000" :autosize="{ minRows: 5}" v-model="ruleForm.czCzjgwb" show-word-limit type="textarea"/>
                    </el-form-item>
                    <Workorder_file paddingLeft="146" :fileList="fileList" @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, onMounted, ref, getCurrentInstance, watch} from 'vue';
    import {dateFormat} from '../../assets/js/base.js';
    import {useStore} from 'vuex';
    import Workorder_file from './Wordorder_file.vue';
    import {ElMessageBox,ElLoading} from 'element-plus'

    export default {
        name: "WorkorderGDGP",
        props: ["gdId", "timeCzJz"],
        components: {
            Workorder_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const fileList= ref();
            const ruleForm = reactive({
                "czCzlx": "GDGP",
                "gdId": props.gdId,
                "czFpclsxxs": "",
                "clsx": "",//处理时限
                "czFpclsxzrr": "",
                "czFpdxjzrq": "",
                "czCzjgwb": "",
                "userCodes": [
                    {
                        "assignee": "",//被分配人ID
                        "assignee_array": "",//被分配人ID
                        "type": false,//是否主责
                    },
                    // {
                    //     "assignee": "",//被分配人ID
                    //     "type": false,//是否主责
                    // }
                ],
                fileIds: [],
            });
            const addHoldUnit = () => {
                ruleForm.userCodes.push(
                    {
                        "assignee": "",//被分配人ID
                        "assignee_array": "",//被分配人ID
                        "type": false,//是否主责
                    }
                );
            }
            const reduceHoldUnit = (param) => {
                ruleForm.userCodes.splice(param, 1);
            }
            const ruleFormRef = ref()

            const mainResponsibilityChange = (key, index) => {
                if (ruleForm[key][index].type) {
                    ruleForm[key][index].type = false;
                } else {
                    ruleForm[key].map((x) => {
                        return x.type = false
                    });
                    ruleForm[key][index].type = true;
                }

            }
            const getCheckedNodes = (param) => {
                console.log(ruleForm)

            }
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if (action == "confirm") {
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("gdChildToParent");
                                        store.state.addNewWorkorderSuccess = true;
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            let clsxHourDisable = ref(false);//处理时限小时
            let clsxDayDisable = ref(false);//处理时限自然日
            const clsxHourInput = (param) => {
                if (param) {
                    ruleForm.clsx = +param;
                    clsxDayDisable.value = true;
                    clsxHourDisable.value = false;
                    var nowDate = new Date();
                    nowDate.setHours(nowDate.getHours() + Number(param))
                    ruleForm.czFpdxjzrq = dateFormat(nowDate)
                } else {
                    ruleForm.clsx = "";
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                }
            };
            const clsxDayInput = (param) => {
                if (param) {
                    ruleForm.clsx = +param;
                    clsxDayDisable.value = false;
                    clsxHourDisable.value = true;
                    var nowDate = new Date();
                    nowDate.setDate(nowDate.getDate() + Number(param));
                    ruleForm.czFpdxjzrq = dateFormat(nowDate);
                } else {
                    ruleForm.clsx = "";
                    clsxHourDisable.value = false;
                    clsxDayDisable.value = false;
                }
            }
            let cbUnit = ref([]);
            //被选中的承办单位
            let selectedUserCodes = ref([])
            //递归所有的承办单位
            const dgArray = (param) => {
                for (let i in param) {
                    if (selectedUserCodes.value.indexOf(param[i].value) > -1) {
                        param[i].disabled = true;
                    } else {
                        param[i].disabled = false;
                    }
                    if (param[i].children && param[i].children.length > 0) {
                        dgArray(param[i].children)
                    }
                }
            }
            watch(() => ruleForm.userCodes, (newVal) => {
                selectedUserCodes.value = [];
                for (let i in newVal) {
                    if (newVal[i].assignee_array) {
                        newVal[i].assignee = mapValue[newVal[i].assignee_array]
                        selectedUserCodes.value.push(newVal[i].assignee)
                    }
                }
                dgArray(cbUnit.value)
            }, {deep: true})
            //承办单位deptId映射value
            let mapValue = {}
            const deptIdToValue = (param)=>{
                param.map(item=>{
                    if( item.children && Array.isArray(item.children) && item.children.length>0){
                        deptIdToValue(item.children)
                    }else{
                        mapValue[item.deptId] = item.value;
                    }
                })
            }
            onMounted(() => {
                proxy.$axios.post("/jgfast/wgsj/selCbdw").then((res) => {
                    cbUnit.value = res.data;
                    deptIdToValue(res.data)
                }).then(()=>{
                    proxy.$axios.post("/jgfast/wgsj/getJxzfpcz", {
                        gdId: props.gdId
                    }).then((res) => {
                        if (Object.getOwnPropertyNames(res.data).length>0) {
                            ruleForm.czFpclsxzrr = Number(res.data.czFpclsxzrr);
                            ruleForm.clsx = Number(res.data.czFpclsxzrr);
                            ruleForm.czFpdxjzrq = res.data.czFpdxjzrq;
                            ruleForm.czCzjgwb = res.data.czCzjgwb;
                            ruleForm.userCodes = res.data.userCodes;
                            fileList.value = res.data.files;
                            ruleForm.userCodes.map((item,index)=>{
                                Object.keys(mapValue).map(item1=>{
                                    if(mapValue[item1] == item.assignee){
                                        ruleForm.userCodes[index].assignee_array = item1;
                                    }
                                })
                            })
                            res.data.files.map(item => {
                                ruleForm.fileIds.push(item.id)
                            })
                        }
                        if (!res.data.czFpclsxzrr) {
                            ruleForm.czFpclsxzrr = Number(props.timeCzJz.gdCzsx);
                            ruleForm.clsx = Number(props.timeCzJz.gdCzsx);
                        }
                        if (!res.data.czFpdxjzrq) {
                            ruleForm.czFpdxjzrq = props.timeCzJz.gdJzsj;
                        }
                    });
                });
            })
            //取消事件
            const cancleClick = () => {
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if (action == "confirm") {
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            const fileListToParent = (param) => {
                if (param) {
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile = (param) => {
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                addHoldUnit,
                reduceHoldUnit,
                ruleFormRef,
                ruleForm,
                submitForm,
                mainResponsibilityChange,
                clsxHourDisable,
                clsxDayDisable,
                clsxHourInput,
                clsxDayInput,
                cbUnit,
                getCheckedNodes,
                cancleClick,
                fileListToParent,
                deleteFile,
                fileList
            }
        }
    }
</script>

<style scoped>

</style>
